export default __webpack_public_path__ + "static/index-title-feature-zh-Hans-e17144f591d9491876027a37afedb0fd.png";